exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n}\n\n.footer {\n    padding: 20px;\n    background-color: #2d2d2d;\n    color: white;\n    font-family: 'Roboto';\n}\n\na {\n    font-weight: bold;\n    color: #2c89c3;\n    text-decoration: none;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/thibautjacob/Documents/Projects/Portfolio/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main